/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { createStore, createApi, createEffect, sample } from 'effector';

import { getUser, login, logout, changePassword, checkLoginSms } from '../api';
import { UserChangePassword, UserLogin, LoginSmsCode } from '../api/types/user';
import { User } from '../types/user';
import { withPersist } from '../utils/effectorPersist';
import { Nullable } from '../utils/types';

export type TUser$State = Nullable<User>;

export const User$ = withPersist<TUser$State>(createStore<TUser$State>(null));

//@ts-ignore
const { set, remove } = createApi(User$, {
  // @ts-ignore
  set: (state, { result }) => (result?.result === undefined ? state : result.result),
  remove: () => null,
});

export const userApi = {
  get: createEffect().use(getUser),
  login: createEffect<UserLogin, {}, {}>().use(login),
  checkLoginSms: createEffect<LoginSmsCode, {}, {}>().use(checkLoginSms),
  logout: createEffect().use(logout),
  changePassword: createEffect<UserChangePassword, {}, {}>().use(changePassword),
};

sample({
  clock: userApi.get.done,
  target: set,
});

sample({
  clock: userApi.login.done,
  target: set,
});

sample({
  clock: userApi.checkLoginSms.done,
  target: set,
});

sample({
  clock: userApi.logout.done,
  target: remove,
});

sample({
  clock: userApi.changePassword.done,
  target: set,
});

window?.addEventListener('logout', () => {
  userApi.logout('');
});
